import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { stickerService } from "../services/stickerService";
import { workstationPreferenceService } from "../services/workstationPreference.service";

export const useStickerPrinterStatus = () => {
  const [workstationId, setWorkstationId] = useState<string | null>(
    workstationPreferenceService.getSelectedWorkstationId()
  );

  useEffect(() => {
    const unsub = workstationPreferenceService.onChange(() => {
      setWorkstationId(workstationPreferenceService.getSelectedWorkstationId());
    });
    return unsub;
  }, []);

  return useQuery({
    queryKey: ["stickerPrinterStatus", workstationId],
    queryFn: () => stickerService.getPrinterStatus(workstationId as string),
    enabled: !!workstationId,
    refetchInterval: 30000,
  });
};
